import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Github } from 'lucide-react';

export default function CalendarFooter() {
  const navigate = useNavigate();

  const handleCreateCalendar = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    navigate('/login?signup=true');
  };

  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <a
            href="/login?signup=true"
            onClick={handleCreateCalendar}
            className="text-sm text-gray-500 hover:text-gray-800 transition-colors"
          >
            Create a free calendar
          </a>
          <a
            href="https://github.com/greentechgear/calenlist"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors"
          >
            <Github className="h-3.5 w-3.5" />
            Open source
          </a>
        </div>
      </div>
    </footer>
  );
}
